import React,{ useState, useEffect, useRef } from 'react';
import { useNavigate  } from 'react-router-dom';

import Reviews from '../../../components/Reviews/Reviews'
import AutoScrolling from '../../../components/AutoScrolling/AutoScrolling'
import BigCard from '../../../components/BigCard/BigCard';
import AutoSwitching from '../../../components/AutoSwitching/AutoSwitching';


import './Reviews.less'

const ReviewsPage = () =>{
  const navigate = useNavigate();
  const [selectExpert, setSelectExpert] = useState(null)

  let expertList = [{
    img: require('../../../image/expert1.avif'),
    name: 'Dr. Casey Means, MD',
    identity: 'Physician, author & health tech entrepreneur',
    sentence: 'Improving the quality of our mitochondria helps us live healthier and longer lives. '
  },{
    img: require('../../../image/expert2.avif'),
    name: 'Dr. Mark Hyman, MD',
    identity: 'Functional Medicine Physician, 15x New York Times Bestselling Author',
    sentence: 'This is a supplement I use myself everyday to be as healthy as I can, for as long as I can.'
  },{
    img: require('../../../image/expert3.avif'),
    name: 'Dr. Gabrielle Lyon',
    identity: 'Founder Institute for Muscle-Centric Medicine®',
    sentence: 'No other supplement does what Timeline can. It is an amazing advance for muscle health and longevity.'
  },{
    img: require('../../../image/expert4.avif'),
    name: 'Dr. Johan Auwerx MD, PhD',
    identity: 'Scientific Advisor',
    sentence: 'The latest clinical study really crystallizes how Mitopure can be a real game-changer for human health.'
  },{
    img: require('../../../image/expert5.avif'),
    name: 'Eric Verdin, MD',
    identity: 'CEO Buck Institute for Research on Aging, Scientific Advisor',
    sentence: 'Mitochondrial decline is a key hallmark of aging and Mitopure is one of the most promising compounds in our field'
  }]
  let AutoSwitchingData = {
    title: 'Hear from thought leaders',
    data: expertList
  }

  let bigCardData = {
    type: 'bgCard',
    bgImg: require('../../../image/bigCardBg-3840x1440.png'),
    textWidth: '30%',
    textPosition: 'right',
    title: 'How Mitopure® regenerates cells',
    description: 'Mitopure® was developed after over a decade of scientific research. Dig deeper into the science behind a game-changing discovery for cellular health.',
    btnConfig:{
      text: 'shop all',
      link: '/shop'
    }
  }

  let timerRef = useRef();
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    let num = 0;
    setSelectExpert(num)
    timerRef.current = setInterval(()=>{
      num++
      if(num === 5) num = 0
      console.log(num)
      setSelectExpert(num)
    }, 10000)
 
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);

    // 清理函数，组件卸载时移除监听器
    return () => {
      clearInterval(timerRef.current)
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  if(width > 770){
    return (
      <div className="Reviews-Page">
        <div style={{borderBottom: '1px solid rgba(0,0,0,0.12)'}}>
          <div className="bigTitle">
            Reviews from experts and verified buyers
          </div>
        </div>
        
        <Reviews reviewsData={{}} isName={false}/>
  
        <AutoScrolling />
  
        {/* 专家 */}
        <AutoSwitching AutoSwitchingData={AutoSwitchingData}/>
  
        <BigCard bigCardData={bigCardData}/>
      </div>
    )
  }else{
    return (
      <div className="Reviews-Page">
        <div style={{borderBottom: '1px solid rgba(0,0,0,0.12)'}}>
          <div style={{width: '100%', maxWidth: 1440, fontSize: 'clamp(40px, calc(31.55px + 2.25vw), 64px)', padding: '30px 25px'}}>
            Reviews from experts and verified buyers
          </div>
        </div>
        
        <Reviews reviewsData={{}} isName={false}/>
  
        <AutoScrolling />
  
        {/* 专家 */}
        <AutoSwitching AutoSwitchingData={AutoSwitchingData}/>
  
        <BigCard bigCardData={bigCardData}/>
      </div>
    )
  }
}

export default ReviewsPage